<template>
  <div class="d-flex flex-column" style="height:100vh;">
    <!-- TODO: apply any markup that is common to all private views and not shared with the public views Private View -->
      <appHeader></appHeader>
      <b-container class="wrapper px-0" fluid>
        <router-view></router-view>
      </b-container>
    <appFooter
      class="bottom-footer mt-auto"
      v-on:showModal="openModal($event)"
      >
    </appFooter>
    <b-modal v-model="modalShow" hide-header hide-footer size="lg" >
      <simpleModalHeader @closeModal="closeModal" />
      <component :is="modalComponent"></component>
    </b-modal>
  </div>

</template>

<script>
import appHeader from './shared/components/header'
import appFooter from './shared/components/footer'
import simpleModalHeader from './shared/components/simple_modal_header'
import footerAddress from './shared/components/footer/address'
import emailAddress from './shared/components/footer/email_address'
import footerContact from './shared/components/footer/footer_contact'
import footerTerms from './shared/components/footer/terms_conditions'
import footerCancellation from './shared/components/footer/cancellation_policy'
import b2bInstructions from './shared/components/footer/b2b_instructions'

export default {
  components: { appHeader, appFooter, simpleModalHeader, footerAddress, emailAddress, footerContact, footerTerms, footerCancellation, b2bInstructions },
  data () {
    return {
      modalShow: false,
      modalComponent: null
    }
  },
  methods: {
    openModal (type) {
      if (type === 'address') {
        this.modalComponent = footerAddress
      } else if (type === 'email') {
        this.modalComponent = emailAddress
      } else if (type === 'contact') {
        this.modalComponent = footerContact
      } else if (type === 'terms') {
        this.modalComponent = footerTerms
      } else if (type === 'cancel') {
        this.modalComponent = footerCancellation
      } else {
        this.modalComponent = b2bInstructions
      }
      this.modalShow = true
    },
    closeModal () {
      this.modalShow = false
    }
  }
}
</script>
